import { Rs005CardIComponent } from './../views/form-rs005/partialViews/rs005-card-I.component';
import { NotificationService } from './notification.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { ActionMessage, TypeMessage } from '../entity/enum/enum-notification';
import { GeneralService } from './general.service';
import { take } from 'rxjs/operators';
import { EnumForm } from '../entity/enum/enum-form';
import { SelectedArea } from '../shared/area-select.component';
@Injectable()
export class FormularioService extends BaseService<any> {

    public pageSizeOptions?: number[] = [25, 50, 100, 500, 1000, 2000];
    public firstPageLabel: string = 'Primeira página';
    public lastPageLabel: string = 'Ultima página';
    public itemsPerPageLabel: string = 'Itens por página';
    public nextPageLabel: string = 'Próxima página';
    public previousPageLabel: string = 'Voltar página';
    private arrFormWithControl: EnumForm[] = [
        EnumForm.FormCd001Classificacao,
        EnumForm.FormCd001PreLimpeza,
        EnumForm.FormEt004,
        EnumForm.FormSec002
    ];

    savedResponse: any = null;

    constructor(http: HttpClient, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super(http);
    }

    getCd001DataFromLote(pLoteCs?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/cd001/info/classificacao`, { lote_cs: pLoteCs }, { headers: this.getOptions() });
    }

    // Service puxar dados PC003 partindo do contrato e gleba

    // getPc003Data(pContratoJuridico?: string, pGleba?: string): Observable<any> {
    //     // tslint:disable-next-line: max-line-length
    //     return this.http.post<any>(`${environment.api}v1/pc003/info`, { contrato_juridico: pContratoJuridico, gleba: pGleba }, { headers: this.getOptions() });
    // }

    // Service puxar dados PC003 partindo apenas do contrato

    getcd003Data(controle_analise_ca?: string, site_beneficiamento?: string, safra?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/cd003/info`, { controle_analise_ca, site_beneficiamento, safra }, { headers: this.getOptions() });
    }


    getPc003Data(pContratoJuridico?: string, safra = null, numero_campo = null): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/pc003/info`, { contrato_juridico: pContratoJuridico, safra, numero_campo }, { headers: this.getOptions() });
    }

    getQua007Contrato(data?: any): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/qua007/safra/numero_campo/info`, data, { headers: this.getOptions() });
    }

    getPc003TorreData(pContratoJuridico?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/pc003/torre`, { contrato_torre: pContratoJuridico }, { headers: this.getOptions() });
    }

    getPc003ByHibridoData(hibrido?: string,): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/pc003/contrato`, { hibrido_rnc: hibrido }, { headers: this.getOptions() });
    }


    getSec002Data(loteDs?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/sec002/info`, { lote_ds: loteDs }, { headers: this.getOptions() });
    }

    getLotesFromSec002Data(hibrido?: string, safra?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/sec002/hibrido/info`, { hibrido_rnc_linhagem: hibrido, safra: safra }, { headers: this.getOptions() });
    }

    getListHibridoBySafraWithLoteDs(safra?: string): Observable<any> {
        return this.http.post<any>(`${environment.api}v1/sec002/hibrido/lotes/info`, { safra }, { headers: this.getOptions() });
    }

    getPeneirasFromCd006Data(lotes?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/cd006/lotes/info`, { lote_ds: lotes }, { headers: this.getOptions() });
    }

    getInfoFromCd006DataByPeneiras(lotes?: string, peneiraC1?: number, peneiraC2?: number, peneiraC3?: number): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/cd006/peneiras/info`, { lote_ds: lotes, c1_peneira: peneiraC1, c2_peneira: peneiraC2, c3_peneira: peneiraC3 }, { headers: this.getOptions() });
    }

    getInfoReportFromCd006DataByLotes(lotes?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/cd006/lotesGenerator/info`, { lote_ds: lotes }, { headers: this.getOptions() });
    }

    getInfoFromSec002DataByLotes(lotes?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/sec002/lote/info`, { lote_ds: lotes }, { headers: this.getOptions() });
    }

    getInfoFromQua007ToSec002(safra?: string, numero_campo?: string, numero_caixa?: string, cerar_basica?: string) {
        return this.http.post<any>(`${environment.api}v1/sec002/get_qua007_data`, { safra, numero_campo, numero_caixa, cerar_basica }, { headers: this.getOptions() });
    }

    getPesoRWFromQua007(safra?: string, numero_campo?: string, cerar?: string) {
        return this.http.post<any>(`${environment.api}v1/qua007/get_peso_rw_from_qua007`, { safra, numero_campo, cerar }, { headers: this.getOptions() });
    }

    getListDropDownLoteDS(safra, numero_campo): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/sec002/dropdown/loteds`, { safra, numero_campo }, { headers: this.getOptions() });
    }
    getListDropDownLoteSaida(safra, numero_campo): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/rs005/dropdown/loteSaida`, { safra, numero_campo }, { headers: this.getOptions() });
    }

    getProporcaoSilosData(loteDs?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/proporcao_silos/info`, { lote_ds: loteDs }, { headers: this.getOptions() });
    }

    getHumidityData(pCerar?: string): Observable<any> {
        return this.http.post<any>(`${environment.api}v1/rs009/humidity`, { cerar: pCerar }, { headers: this.getOptions() });
    }

    getFxBlueHumidityData(pUmidade?: string, pHibrido?: string, pTipoColheita?: string, psafra?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/formula/fau`, { umidade: pUmidade, hibrido: pHibrido, tipo_colheita: pTipoColheita, safra: psafra }, { headers: this.getOptions() });
    }

    getCountWeekAfterHarvestStart(pSiteRecebimento?: string, pDataColheita?: string, safra?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/formula/count/weeks`, { site_recebimento: pSiteRecebimento, data_colheita: pDataColheita, safra: safra }, { headers: this.getOptions() });
    }

    getTonHrLns(pPesoLiquido?: string, pTempDescarga?: string, pLinhaDesc?: string, pSite?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/formula/thl`, { volume: pPesoLiquido, tempo: pTempDescarga, linha: pLinhaDesc, site: pSite }, { headers: this.getOptions() });
    }

    getFormFat(pTempMaxTrajeto?: string, pTempMaxTransporte?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/formula/fat`, { temperatura_maxima_trajeto: pTempMaxTrajeto, temperatura_maxima_tempo: pTempMaxTransporte }, { headers: this.getOptions() });
    }

    getFormFatNm(pTempEsperaPatio?: string, pTempTotalTransporte?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/formula/fatnm`, { tempo_espera_patio: pTempEsperaPatio, tempo_total_transporte: pTempTotalTransporte }, { headers: this.getOptions() });
    }

    // tslint:disable-next-line: max-line-length
    getFormFag(pFaixaAzulCampo?: string, pFaixaAzulUmidade?: string, pFaixaAzulTemperatura?: string, pFaixaAzulTempo?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/formula/fag`, { faixa_azul_campo: pFaixaAzulCampo, faixa_azul_umidade: pFaixaAzulUmidade, faixa_azul_temperatura: pFaixaAzulTemperatura, faixa_azul_tempo: pFaixaAzulTempo }, { headers: this.getOptions() });
    }

    getLastMonday(pDataColheita?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/formula/last/monday`, { data_colheita: pDataColheita }, { headers: this.getOptions() });
    }

    getUser(): Observable<any> {
        return this.http.get<any>('/auth-token-info', { headers: this.getOptions() });
    }

    getQua007Data(pCerar?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/qua007/data`, { cerar: pCerar }, { headers: this.getOptions() });
    }

    getQua007DataByContrato(contrato?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/qua007/contrato_juridico/info`, { contrato_juridico: contrato }, { headers: this.getOptions() });
    }

    getCd006DataByContrato(contrato?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/cd006/contrato_juridico/info`, { contrato_juridico: contrato }, { headers: this.getOptions() });
    }

    getCd006DataByLoteDs(loteDs?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/cd006/lote_ds/info`, { lote_ds: loteDs }, { headers: this.getOptions() });
    }

    getEt004Data(pControle_analise_et004?: string, pSafra?: string, pCentro_ensaque?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/et004/info`, { controle_analise_et004: pControle_analise_et004, safra: pSafra, centro_ensaque: pCentro_ensaque }, { headers: this.getOptions() });
    }

    getRs009Info(pCerar?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/rs009/info`, { cerar: pCerar }, { headers: this.getOptions() });
    }

    getCd001ClassificacaoData(pNumeroControle?: string, pSiteRecebimento?: string, pSafra?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/cd001/classificacao`, { numero_controle: pNumeroControle, site_recebimento: pSiteRecebimento, safra: pSafra }, { headers: this.getOptions() });
    }

    checkValueExists(pField?: string, pSheet?: string, pValue?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/field/exists`, { campo: pField, planilha: pSheet, valor: pValue }, { headers: this.getOptions() });
    }

    getQua007DataToSec002(pSiteRecebimento?: string, pSafra?: string, pControleSecagem?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/qua007/info`, { site_recebimento: pSiteRecebimento, safra: pSafra, controle_secagem: pControleSecagem }, { headers: this.getOptions() });
    }

    getGlebaFromSec002ByCerarAndSafra(safra?: string, cerar?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/sec002/get_data_to_rs005`, { safra, cerar }, { headers: this.getOptions() });
    }
    getGlebaFromQua007ByCerarAndSafra(safra?: string, cerar?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/qua007/gleba/info`, { safra, cerar }, { headers: this.getOptions() });
    }

    getDataFromSec002ByNumCampoAndSafra(safra?: string, numero_campo?: string, cerar?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/sec002/get_data_from_sec002_to_rs005`, { safra, numero_campo, cerar }, { headers: this.getOptions() });
    }

    getControleSecagemQu007(safra?: string, numero_campo?: string, caixa?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/qua007/get_controle_secagem_from_qua007`, { safra, numero_campo, caixa }, { headers: this.getOptions() });
    }

    getPesoPosSecagemSec002(safra?: string, numero_campo?: string, caixa?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/sec002/get_pesopossecagem_sec002`, { safra, numero_campo, caixa }, { headers: this.getOptions() });
    }


    getRS005Data(safra?: string, numero_campo?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/rs009/get_data_from_rs005`, { safra, numero_campo }, { headers: this.getOptions() });
    }

    calcGetQua007DataToSec002(pCerar?: string) {
        return this.http.post<any>(`${environment.api}v1/qua007/sdc_despalha`, { cerar: pCerar }, { headers: this.getOptions() });
    }

    getDataFromSdcDespalha(pCerar?: string) {
        return this.http.post<any>(`${environment.api}v1/qua007/alterarmetodo`, { cerar: pCerar }, { headers: this.getOptions() });
    }

    getListLoteDSForCamisaTrieur(safra?: string, hibrido_rnc_linhagem?: string) {
        return this.http.post<any>(`${environment.api}v1/cd006/dropdown/loteds`, { safra, hibrido_rnc_linhagem }, { headers: this.getOptions() });
    }

    getDadosFromLoteDS(safra?: string, list_lote_ds?: [], site_beneficiamento?: string) {
        return this.http.post<any>(`${environment.api}v1/cd006/rendimentos/info`, { safra, list_lote_ds, site_beneficiamento }, { headers: this.getOptions() });
    }
    checkNumeroCampo(sheet?: string, model?: any): Observable<any> {
        return this.http.post<any>(`${environment.api}v1/sheet/${sheet}/check/numero_campo`, model, { headers: this.getOptions() });
    }

    public async saveForm(id?: number, objJson?: any, sheet?: string, descSheet?: string): Promise<void> {
        id = !!id ? id : 0;
        let array = [];
        let idToRemove: number = id;

        if (!localStorage.hasOwnProperty(`data_${sheet}`)) {
            localStorage[`data_${sheet}`] = JSON.stringify(array);
        }

        const status = await this.getConnectionStatus();
        // this.generalService.getConnectionStatus().subscribe(async status => {

        if (objJson.hasOwnProperty('offline')) {
            delete objJson['offline'];
        }

        if (id === 0) {
            if (status) {
                this.create(sheet, objJson).pipe(take(1)).toPromise().then((response: any) => {
                    this.savedResponse = response;
                    this.AddRecordOnline(sheet, descSheet, idToRemove, response);
                }).catch(async (error: HttpErrorResponse) => {
                    this.showNotificationError(error);
                });
            } else {
                this.AddRecordOffline(objJson, sheet, descSheet);
            }
        } else if (id > 0) {
            // this.generalService.getConnectionStatus().subscribe(async status => {
            if (status) {
                this.update(sheet, objJson).pipe(take(1)).toPromise().then((response: any) => {
                    this.savedResponse = response;

                    this.updateRecordOnline(descSheet);
                }).catch((error: HttpErrorResponse) => {
                    this.showNotificationError(error);
                });
            } else {
                this.UpdateRecordOffline(id, objJson, sheet, descSheet);
            }
            // }).unsubscribe();
        };
        // }).unsubscribe();
    }

    // INICIO DE METODOS OFFLINE

    private AddRecordOffline(objJson: any, sheet: string, descSheet: string): void {
        let data = JSON.parse(localStorage.getItem(`data_${sheet}`));
        delete objJson['id'];
        objJson['id'] = Date.now();
        objJson['offline'] = true;
        data.push(objJson);
        localStorage[`data_${sheet}`] = JSON.stringify(data);
        this.generalService.goToRoute(descSheet);
        this.notificationService.sendNotification('', TypeMessage.New, ActionMessage.Success);
    }

    private UpdateRecordOffline(id: number, objJson: any, sheet: string, descSheet: string): void {
        let data = JSON.parse(localStorage.getItem(`data_${sheet}`));
        let idx = data.findIndex(element => { return element.id == id });
        objJson['id'] = id;
        objJson['offline'] = true;
        data[idx] = objJson;
        localStorage[`data_${sheet}`] = JSON.stringify(data);
        this.generalService.goToRoute(descSheet);
        this.notificationService.sendNotification('', TypeMessage.Edit, ActionMessage.Success);
    }

    // FIM DE METODOS OFFLINE

    // INICIO DE METODOS ONLINE

    private AddRecordOnline(sheet: string, descSheet: string, idToRemove: number, response: any): void {
        if (localStorage.hasOwnProperty(`data_${sheet}`)) {
            let data = JSON.parse(localStorage.getItem(`data_${sheet}`));
            let idx = data.findIndex(element => { return element.id == idToRemove });
            data.splice(idx, 1);
            localStorage[`data_${sheet}`] = JSON.stringify(data);

            let controle = 0;
            switch (sheet) {
                case 'cd001_classificacao': controle = response.data.numero_controle; break;
                case 'cd001_prelimpeza': controle = response.data.numero_controle; break;
                case 'sec002': controle = response.data.controle_secagem; break;
                case 'et004': controle = response.data.ca_tratamento_controle_analise; break;
                default: controle = response.data.id;
            }
            this.showNotificationSave(
                '',
                TypeMessage.New,
                ActionMessage.Success,
                this.generalService.getMapEnumFormDesc(sheet),
                descSheet,
                controle,
            );
        }
    }

    private updateRecordOnline(descSheet: string): void {
        this.showNotificationSave(
            '',
            TypeMessage.Edit,
            ActionMessage.Success,
            EnumForm.Desconhecido,
            descSheet,
            0
        );
    }

    // FIM DE METODOS ONLINE

    private showNotificationError(error: HttpErrorResponse): void {
        this.notificationService.showNotificationError(error, error.message);
    }

    private async showNotificationSave(message: string, typeMessage: TypeMessage, actionMessage: ActionMessage, form: EnumForm, route: string, controle: number): Promise<void> {
        if (this.arrFormWithControl.includes(form)) {
            this.notificationService.sendNotificationControl(
                message,
                typeMessage,
                actionMessage,
                form,
                controle, //TODO: PEGAR O CONTROLE GERADO NO BACK E PASSAR PRA CA
                route
            )
        } else {
            this.generalService.goToRoute(route);
            this.notificationService.sendNotification(message, typeMessage, actionMessage);
        }
    }

    public validForm(arrForms?: Array<FormGroup>): string {
        for (const form of arrForms) {
            if (!form.valid && form.enabled) {
                console.log(form)
                this.notificationService.sendNotification('', TypeMessage.FormValid, ActionMessage.Info);
                form.markAllAsTouched();
                return 'Erro';
            }
        }
        return '';
    }

    public cleanForm(arrForms?: Array<FormGroup>): void {
        for (const form of arrForms) {
            form.reset();
        }
    }

    private getConnectionStatus(): boolean {
        if (localStorage.getItem('statusNetwork')) {
            let isOnline = JSON.parse(localStorage.getItem('statusNetwork'));
            return isOnline;
        } else {
            return true;
        }
    }

    userIsAdmin(): Observable<boolean> {
        return this.http.get<boolean>(`${environment.api}v1/users/adm/isAdmin`, { headers: this.getOptions() });
    }

    getInfoReportFromDadosFisiologicosDataByLotes(lote?: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.post<any>(`${environment.api}v1/dados_fisilogicos/dadosFisiologicos/info`, { lote: lote }, { headers: this.getOptions() });
    }

    userIsManager(): Observable<boolean> {
        return this.http.get<boolean>(`${environment.api}v1/users/adm/isManager`, { headers: this.getOptions() });
    }

    async checkCerarExist(cerar: string, formGroup: FormGroup, site: string): Promise<boolean> {
        let result = false;

        // Criação das promessas de forma condicional
        const promiseRs009 = site === 'rs009' ? this.checkValueExists('cerar', 'rs009', cerar).pipe(take(1)).toPromise() : null;
        const promiseRs005 = site === 'rs005' ? this.checkValueExists('cerar', 'rs005', cerar).pipe(take(1)).toPromise() : null;
        const promiseQua007 = this.checkValueExists('cerar', 'qua007', cerar).pipe(take(1)).toPromise();

        try {
            // Verificação do rs009
            if (promiseRs009) {
                const rs009Data = await promiseRs009;
                if (rs009Data.data === true) {
                    this.notificationService.sendNotification(
                        `O Cerar ${cerar} já está cadastrado na base rs009, favor inserir outro.`,
                        TypeMessage.Personalized,
                        ActionMessage.Info
                    );
                    result = true;
                    formGroup.get('Cerar').setErrors({ invalidCerar: true });
                    return result; // Saída precoce se o cerar já existe no rs009
                }
            }

            // Verificação do rs005
            if (promiseRs005) {
                const rs005Data = await promiseRs005;
                if (rs005Data.data === true) {
                    this.notificationService.sendNotification(
                        `O Cerar ${cerar} já está cadastrado na base rs005, favor inserir outro.`,
                        TypeMessage.Personalized,
                        ActionMessage.Info
                    );
                    result = true;
                    formGroup.get('Cerar').setErrors({ invalidCerar: true });
                    return result; // Saída precoce se o cerar já existe no rs005
                }
            }

            // Verificação do qua007
            const qua007Data = await promiseQua007;
            if (qua007Data.data === false) {
                this.notificationService.sendNotification(
                    `O Cerar ${cerar} não existe na base qua007, favor inserir outro.`,
                    TypeMessage.Personalized,
                    ActionMessage.Info
                );
                result = true;
                formGroup.get('Cerar').setErrors({ invalidCerar007: true });
            } else {
                formGroup.get('Cerar').setErrors(null); // Remove erros se tudo estiver ok
            }
        } catch (error) {
            throw error;
        }

        return result;
    }
    async checkCerarBasicaExist(cerar: string, formGroup: FormGroup, site: string): Promise<boolean> {
        let result = false;

        const promiseRs009 = site == 'rs009' ? this.checkValueExists('cerar_basica', 'rs009', cerar).pipe(take(1)) : null;
        const promiseRs005 = site == 'rs005' ? this.checkValueExists('cerar_basica', 'rs005', cerar).pipe(take(1)) : null;
        const promiseQua007 = this.checkValueExists('cerar_basica', 'qua007', cerar).pipe(take(1));

        try {
            const rs009Data = await promiseRs009.toPromise();

            if ((rs009Data.data as boolean) === true) {
                this.notificationService.sendNotification(`O Cerar ${cerar} já está cadastrado na base de dados, favor inserir outro.`, TypeMessage.Personalized, ActionMessage.Info);
                result = true;
                formGroup.get('cerar_basica').setErrors({ invalidCerar: true });
            } else {
                formGroup.get('cerar_basica').setErrors(null);

                const qua007Data = await promiseQua007.toPromise();

                if ((qua007Data.data as boolean) === false) {
                    this.notificationService.sendNotification(`O Cerar ${cerar} não existe na base qua007, favor inserir outro.`, TypeMessage.Personalized, ActionMessage.Info);
                    result = true;
                    formGroup.get('cerar_basica').setErrors({ invalidCerar007: true });
                }
            }
        } catch (error) {
            throw error;
        }

        return result;
    }

    async checkSiteRecebimento(siteRecebimento: string, formGroup: FormGroup): Promise<boolean> {
        let result = false;
        const siteRecebimentoLocal = this.generalService.getLocalStorageDataSite()

        try {
            if (siteRecebimento != siteRecebimentoLocal) {
                this.notificationService.sendNotification(`O site recebimento ${siteRecebimento} do Cerar esta divergente do site de recebimento selecionado: ${siteRecebimentoLocal} .`, TypeMessage.Personalized, ActionMessage.Info);
                result = true;
                formGroup.get('Cerar').setErrors({ invalidCerarSiteRecebimento: true });
            } else {
                formGroup.get('Cerar').setErrors(null);
            }


        } catch (error) {
            throw error;
        }

        return result;
    }

}
